import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';

/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthService {

  constructor(public afAuth: AngularFireAuth, private fbDB: AngularFireDatabase) {
  }

  signInWithEmail(credentials) {
		// console.log('Sign in with email');
		return this.afAuth.auth.signInWithEmailAndPassword(credentials.email,
			 credentials.password);
  }

  signUp(credentials) {
    // console.log("Register new user");
    return this.afAuth.auth.createUserWithEmailAndPassword(credentials.email, credentials.password);
  }

  logout(){
    this.afAuth.auth.signOut(); 
  }

  resetPassword(email) {
    return this.afAuth.auth.sendPasswordResetEmail(email);
  }

  public getUserData() {
    return new Promise<any>((resolve, reject) => {
      this.afAuth.authState.first().subscribe((user) => {
        if(user) {
          this.fbDB.database.ref("users").child(user.uid).once('value', (snapshot) => {
            let userData = snapshot.val();
            resolve(userData);
          }).catch((error) => {
            // console.log("db query failed error: ", error);
            reject("db query failed error see console");
          });
        } else {
          // console.log("userUID not found");
          reject("userUID not found");
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/auth/auth.ts